import React from 'react';
import { useTranslation } from 'react-i18next';
import { Palette, Radio, Music, Sparkles, Heart, ArrowRight } from 'lucide-react';
import PageTransition from '../components/common/PageTransition';
import SEOHead from '../components/common/SEOHead';
import SectionHeader from '../components/common/SectionHeader';

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageTransition>
      <SEOHead title={t('nav.about')} />
      <div className="space-y-12">
        <SectionHeader
          title={t('about.title')}
          description={t('about.heroSubtitle')}
          iconName="User"
          badge={t('nav.about')}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="art-card p-6 rounded-2xl border-brand-amber/30 space-y-4">
            <div className="p-3 bg-brand-amber/10 w-fit rounded-xl text-brand-amber">
              <Palette className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{t('about.artSection.title')}</h3>
              <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                {t('about.artSection.desc')}
              </p>
            </div>
          </div>

          <div className="art-card p-6 rounded-2xl border-brand-purple/30 space-y-4">
            <div className="p-3 bg-brand-purple/10 w-fit rounded-xl text-brand-purple">
              <Radio className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{t('about.streamSection.title')}</h3>
              <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                {t('about.streamSection.desc')}
              </p>
            </div>
          </div>

          <div className="art-card p-6 rounded-2xl border-emerald-500/30 space-y-4">
            <div className="p-3 bg-emerald-500/10 w-fit rounded-xl text-emerald-500">
              <Music className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{t('about.musicSection.title')}</h3>
              <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                {t('about.musicSection.desc')}
              </p>
            </div>
          </div>
        </div>

        {/* Shop Card */}
        <div className="art-card p-6 rounded-2xl border-emerald-500/30 flex flex-col md:flex-row items-center justify-between gap-6 group">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-brand-amber/10 rounded-full text-brand-amber shrink-0 transition-transform group-hover:scale-110">
              <Heart className="w-6 h-6 fill-current" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-brand-amber mb-1">{t('about.shopCard.title')}</h3>
              <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                {t('about.shopCard.desc')}
              </p>
            </div>
          </div>
          <a
            href="https://shop.kynothan.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-brand-amber hover:bg-amber-400 text-slate-900 text-sm font-bold hover:scale-105 transition-transform shadow-md"
          >
            <span>{t('about.shopCard.cta')}</span>
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </PageTransition>
  );
};

export default About;
